/* eslint @typescript-eslint/no-this-alias: "off" */
import { Injectable } from '@angular/core';

const navigator = window.navigator as Navigator & {
  // TODO: this has been deprecated for a long time, it needs to be updated
  msSaveOrOpenBlob: (blob: Blob, fileName: string) => boolean;
};

@Injectable()
export class BlobDownload {
  public page_active = true;

  constructor() {
    window.addEventListener('focus', () => {
      this.page_active = true;
    });
    window.addEventListener('blur', () => {
      this.page_active = false;
    });
  }

  open(res: Blob, fileName: string, format?: string, doOpen = true) {
    const $this = this;
    if (!navigator?.msSaveOrOpenBlob?.(res, fileName)) {
      const fileURL = URL.createObjectURL(res);
      if (format === 'pdf' && doOpen) {
        try {
          if (!window.navigator.userAgent.match(/Chrome/i) && window.navigator.userAgent.match(/Safari/i)) {
            window.location.href = fileURL;
          } else {
            window.open(fileURL);
          }
        } catch (error) {
          console.log(error);
        }

        const self = this;
        setTimeout(function () {
          if ($this.page_active) { // if the page is still active then opening new tab didn't work, try another approach
            self.downloadBlob(fileURL, fileName);
          }
        }, 200);

      } else {
        this.downloadBlob(fileURL, fileName);
      }

    }
  }

  downloadBlob(fileURL: string, fileName: string) {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.href = fileURL;
    a.download = fileName;
    a.click();
    a.remove();
  }

  download(res: Blob, fileName: string) {
    if (!navigator?.msSaveOrOpenBlob?.(res, fileName)) {
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.href = URL.createObjectURL(res);
      a.download = fileName;
      a.click();
      a.remove();
    }
  }
}
